module.exports = __webpack_public_path__ + "images/238b8ac0e4b4adcff9066750e6fad6d8.png";